import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtDate } from "@/lib/api";
import { EmptyState, PageHeader, TypeChip, VoiceBadge } from "@/components/ui-bits";

const FILTERS = [["", "All"], ["generated", "Drafts"], ["copied", "Copied"], ["sent", "Sent"]];
const ACTION_LABEL: Record<string, string> = { planned: "Planned", generated: "Generated", refined: "Refined", copied: "Copied", marked_sent: "Marked as sent", skipped: "Skipped", rescheduled: "Rescheduled", campaign_generated: "Campaign generated", added_as_sample: "Added as voice sample" };

export default function EmailsPage() {
  const [emails, setEmails] = useState<any[]>([]);
  const [activity, setActivity] = useState<any[]>([]);
  const [filter, setFilter] = useState("");
  useEffect(() => { api.get(`/emails${filter ? `?status=${filter}` : ""}`).then((r) => setEmails(r.data)); }, [filter]);
  useEffect(() => { api.get("/activity").then((r) => setActivity(r.data)); }, []);
  return (
    <div>
      <PageHeader eyebrow="Emails" title="Everything you've written" subtitle="Drafts, copied and sent. Only emails you mark as sent shape future recommendations." testId="emails-header" />
      <div className="grid xl:grid-cols-[1fr_340px] gap-6">
        <section>
          <div className="inline-flex rounded-full border border-line bg-cream p-1 text-xs font-semibold mb-4">{FILTERS.map(([v, l]) => <button key={v} onClick={() => setFilter(v)} className={`rounded-full px-4 py-1.5 ${filter === v ? "bg-navy text-cream" : "text-ink-muted"}`} data-testid={`emails-filter-${v || "all"}`}>{l}</button>)}</div>
          {emails.length === 0 ? <EmptyState title="No emails here yet" body="Write one from Today, the Calendar, or I Need an Email Now." action={<Link to="/app/quick" className="btn-ink">Write an email</Link>} testId="emails-empty" /> : (
            <ul className="space-y-2" data-testid="emails-list">
              {emails.map((e) => (
                <li key={e.id}>
                  <Link to={`/app/emails/${e.id}`} className="card-soft p-4 flex flex-col sm:flex-row sm:items-center gap-3 hover:border-navy/30 transition-colors" data-testid={`email-row-${e.id}`}>
                    <div className="flex-1 min-w-0"><div className="flex items-center gap-2 flex-wrap"><TypeChip type={e.type} /><span className={`chip capitalize ${e.status === "sent" ? "bg-olive-light text-olive-deep" : "bg-sand text-ink-muted"}`}>{e.status}</span></div><p className="font-semibold mt-2 truncate">{e.subject}</p><p className="text-xs text-ink-soft mt-0.5">{e.status === "sent" ? `Sent ${fmtDate(e.sent_at)}` : e.planned_date ? `Planned ${fmtDate(e.planned_date)}` : `Generated ${fmtDate(e.generated_at)}`}</p></div>
                    <VoiceBadge level={e.voice_match} size="sm" />
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </section>
        <aside className="card-soft p-5 max-h-[70vh] overflow-y-auto" data-testid="activity-feed">
          <p className="eyebrow">Activity</p>
          <ul className="mt-3 space-y-3">
            {activity.length === 0 && <li className="text-xs text-ink-soft">Nothing yet.</li>}
            {activity.slice(0, 60).map((a) => (
              <li key={a.id} className="text-xs border-l-2 border-line pl-3" data-testid={`activity-${a.id}`}><p><b>{ACTION_LABEL[a.action] || a.action}</b> <span className="text-ink-soft">· {new Date(a.created_at).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })}</span></p><p className="text-ink-muted truncate">{a.details?.subject || a.details?.topic || a.details?.name || a.details?.action || ""}</p></li>
            ))}
          </ul>
        </aside>
      </div>
    </div>
  );
}
